import styles from "../../styles/PLMApp.module.css";
// src/components/plm/StepNode.jsx

import StatusToggle from "./StatusToggle";

export default function StepNode({
  step,
  docId,
  index,
  category,
  onOpen,
  onStatusChange,
  statusDisabled = false,
  isAdmin,
}) {
  const status = step?.status || "not_started";

  const nodeClass = [
    styles.stepNode,
    status === "done" ? styles.stepNodeDone : "",
    status === "blocked" ? styles.stepNodeBlocked : "",
    status === "in_progress" ? styles.stepNodeInProgress : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={nodeClass} onClick={() => onOpen(docId, index)}>
      {step?.notes && (
        <div className={styles.stepNotesFlag} title="Has notes" />
      )}

      {step?.docCount > 0 && (
        <div className={styles.stepDocFlag} title="Has documents" />
      )}

      <div className={styles.stepNum}>{String(index + 1).padStart(2, "0")}</div>

      <div className={styles.stepTitle}>
        {step?.stepTitle || category.steps[index]}
      </div>

      <StatusToggle
        currentStatus={status}
        disabled={statusDisabled || !isAdmin}
        onSelect={(s) => {
          if (statusDisabled || !isAdmin) return; // ← same guard
          onStatusChange(docId, s);
        }}
      />

      {step?.handler && (
        <div className={styles.stepHandler}>{step.handler}</div>
      )}
    </div>
  );
}
